<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue';
import { FreeMode } from 'swiper/modules';
import { getProviderImage, getProviderStyle } from '@/utils/providerImages';

const router = useRouter();
const { providers } = useOrderedProviders();

const modules = [FreeMode];

const navigateToProvider = (slug: string) => {
  router.push(`/games/category/all?initialProvider=${slug}`);
};
</script>

<template>
  <div :class="[$style.providersWrapper]">
    <Swiper
      class="w-full"
      :free-mode="true"
      :modules="modules"
      :slides-per-view="'auto'"
      :space-between="8"
    >
      <SwiperSlide
        v-for="(opt, i) in providers"
        :key="i"
        class="w-auto flex-shrink-0"
      >
        <button
          class="flex justify-center items-center gap-2.5 px-[28px] py-[10px] rounded-[12px] h-[40px] w-auto border border-white/10 cursor-pointer active:scale-95 transition-transform"
          :class="$style.providerButton"
          @click="navigateToProvider(opt.slug)"
        >
          <div
            v-if="getProviderImage(opt.slug)"
            :class="$style.providerImageWrapper"
          >
            <NuxtImg
              :alt="opt.slug"
              :class="$style.providerImage"
              :draggable="false"
              :src="getProviderImage(opt.slug)"
              :style="getProviderStyle(opt.slug)"
            />
          </div>
          <span
            v-else
            class="text-white text-[11.051px] font-bold leading-[11.051px]"
          >
            {{ opt.slug }}
          </span>
        </button>
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<style module lang="postcss">
.providerButton {
  background: var(--colors-flat-default-flat, rgba(63, 63, 70, 0.4));
}

.providerImage {
  @apply block max-w-full max-h-full object-contain;
}

.providerImageWrapper {
  @apply w-8 h-6 flex items-center justify-center;
}

.providersWrapper {
  @apply relative overflow-hidden pb-5;
}

@media (max-width: 1023px) {
  .providersWrapper {
    margin-right: calc(-1 * var(--container-padding, 16px));
  }
}
</style>
